import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@timely/ui/theme.css';
import App from './App';

const host = document.getElementById('root');
if (!host) throw new Error('index.html is missing its #root element.');

createRoot(host).render(
    <StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </StrictMode>,
);
